import { z } from 'zod'

export enum InquiryStatus {
  READY = 'READY', // 답변 대기
  COMPLETED = 'COMPLETED', // 답변 완료
  CLOSED = 'CLOSED', // 답변 종료 (중복 문의, 유선 안내)
}

export const ZFAQCategory = z.object({
  categoryCode: z.string(),
  categoryName: z.string(),
})

export const ZFAQCategories = z.object({
  categories: z.array(ZFAQCategory),
})

export const ZFAQ = z.object({
  id: z.number(),
  categoryCode: z.string(),
  categoryName: z.string(),
  question: z.string(),
  answer: z.string(),
})

export const ZTopFAQ = ZFAQ.omit({
  categoryCode: true,
})

export const ZTopFAQs = z.object({
  faqs: z.array(ZTopFAQ),
})

export const ZInquiry = z.object({
  id: z.number(), // 문의 ID
  status: z.nativeEnum(InquiryStatus), // 문의 상태
  content: z.string(), // 문의 내용
  answer: z.string().nullable(), // 답변 내용
  createdAt: z.string(), // 문의 생성 일시
  answeredAt: z.string().nullable(), // 답변 일시
})

export const ZNoticeSummary = z.object({
  id: z.number(),
  title: z.string(),
  writeDate: z.string(),
})

export const ZNotice = ZNoticeSummary.extend({
  contents: z.string(),
  previous: ZNoticeSummary.nullable(),
  next: ZNoticeSummary.nullable(),
})

export type TFAQCategory = z.infer<typeof ZFAQCategory>
export type TFAQCategories = z.infer<typeof ZFAQCategories>

export type TFAQ = z.infer<typeof ZFAQ>
export type TTopFAQ = z.infer<typeof ZTopFAQ>
export type TTopFAQs = z.infer<typeof ZTopFAQs>

export type TInquiry = z.infer<typeof ZInquiry>

export type TNotice = z.infer<typeof ZNotice>
export type TNoticeSummary = z.infer<typeof ZNoticeSummary>
